import { Link, usePage } from "@inertiajs/react"
import { House, Clock, FolderOpen } from "lucide-react"
import { cn } from "@/lib/utils"

interface NavItem {
  label: string
  href: string
  icon: React.ElementType
}

const navItems: NavItem[] = [
  { label: "Home", href: "/", icon: House },
  { label: "Recent", href: "/recent-files", icon: Clock },
  { label: "Files", href: "/files", icon: FolderOpen },
]

function isActive(href: string, currentUrl: string): boolean {
  if (href === "/") return currentUrl === "/"
  if (href === "/recent-files") return currentUrl.startsWith("/recent-files")
  return currentUrl.startsWith(href)
}

export function DesktopNav() {
  const { url } = usePage()

  return (
    <nav className="hidden md:flex items-center gap-1" data-testid="desktop-nav">
      {navItems.map((item) => {
        const active = isActive(item.href, url)
        return (
          <Link
            key={item.href}
            href={item.href}
            className={cn(
              "flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-colors",
              active
                ? "bg-primary text-primary-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground hover:bg-accent"
            )}
            data-testid={`nav-${item.label.toLowerCase()}`}
          >
            <item.icon className="h-4 w-4" />
            {item.label}
          </Link>
        )
      })}
    </nav>
  )
}

export function MobileTabBar() {
  const { url } = usePage()

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 flex md:hidden border-t bg-card pb-[env(safe-area-inset-bottom)]"
      data-testid="mobile-tab-bar"
    >
      {navItems.map((item) => {
        const active = isActive(item.href, url)
        return (
          <Link
            key={item.href}
            href={item.href}
            className={cn(
              "flex flex-1 flex-col items-center gap-1 py-2 text-xs font-medium transition-colors",
              active ? "text-primary" : "text-muted-foreground"
            )}
            data-testid={`tab-${item.label.toLowerCase()}`}
          >
            <item.icon className="h-5 w-5" />
            {item.label}
          </Link>
        )
      })}
    </nav>
  )
}
